import { Pane, HelpIcon, FullCircleIcon, CornerDialog, Paragraph, Link, Heading } from 'evergreen-ui';
import { useState } from 'react';

const Support = ({ iconStyle = {}, email = false }) => {
  const [isShown, setIsShown] = useState(false);
  return (
    <>
      <CornerDialog
        title={<Heading color="#fff">Support</Heading>}
        isShown={isShown}
        onCloseComplete={() => setIsShown(false)}
        hasFooter={false}
        position={'bottom-right'}
        width="80%"
        containerProps={{ zIndex: 10, backgroundColor: '#1E262C' }}
      >
        <Paragraph color="#fff">Customer Support</Paragraph>
        {email ? (
          <Link href="mailto:support@grabkings.com">support@grabkings.com</Link>
        ) : (
          <Link href="https://wa.me/447537188768" target="_blank">
            Whatsapp
          </Link>
        )}
      </CornerDialog>
      <Pane position="relative" margin={32} display="flex" justifyContent="flex-end" {...iconStyle}>
        <HelpIcon color="#e78850" onClick={() => setIsShown(true)} size={40} zIndex={1} />
        <FullCircleIcon size={40} color="#ffffff" position="absolute" top="0" />
      </Pane>
    </>
  );
};

export default Support;
